<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M5.5 3.5a2 2 0 012-2h9a2 2 0 012 2v17a2 2 0 01-2 2h-9a2 2 0 01-2-2v-17zM6 18.5h12M6 5h12"/>
</svg>
